<style scoped lang="scss">
  .coupons_box {
    padding-bottom: 10px;
  }
  .coupons {
    &_nodata {
      text-align: center;
      height: 40px;
      line-height: 40px;
    }
    &_ammount {
      float: left;
      width: 120px;
      height: 120px;
      line-height: 120px;
      text-align: center;
      font-size: 12px;
      background: #409eff;
      color: #fff;
      .ammount {
        font-size: 24px;
        font-weight: bold;
      }
    }
    &_ammount_pasted {
      background: #96b0ca;
    }
    &_content {
      float: right;
      width: calc(100% - 160px);
      height: 120px;
      padding-right: 20px;
      div {
        height: 28px;
        line-height: 26px;
      }
      .content {
        float: right;
      }
      .content.reason {
        color: #ff0000;
      }
    }
    &_unpast {
      div {
        height: 36px;
        line-height: 34px;
      }
      div:nth-child(2) {
        height: 48px;
        line-height: 40px;
      }
    }
    &_detail_btn {
      float: left;
    }
    &_use_btn {
      float: right;
    }
    &_detail {
      margin-top:10px;
      border-top: 1px solid #efefef;
      padding: 20px;
    }
    &_past {
      height: 24px;
      line-height: 22px;
    }
  }
  ::v-deep .el-card__body {
    padding: 0;
  }
  ::v-deep .el-row {
    margin-bottom: 6px;
  }
  .clearb {
    clear: both;
  }
</style>

<template>
  <div class="coupons_box">
  <el-tabs type="border-card" v-model="curTab" @tab-click="tabClick">
    <div class="coupons_nodata" v-if="!couponsItems.items || couponsItems.items.length <= 0">您目前没有可用的优惠券...</div>
    <el-tab-pane name="1" :label="canTotal > 0 ? '可使用(' + canTotal + ')' : '可使用'">
      <el-row v-for="(item, index) in couponsItems.items">
        <el-col>
            <el-card shadow="hover" class="coupons">
                <div class="coupons_ammount">$<span class="ammount">{{item.amount}}</span></div>
                <div class="coupons_content coupons_unpast">
                  <div>来源：<span class="content reason">{{item.getReasonDesc}}</span></div>
                  <!--<div>是否过期：
                    <el-tag type="success" class="content coupons_past">未过期</el-tag>
                  </div>-->
                  <div>有效时间：<span class="content">{{isForever(item.expirationTime)}}</span></div>
                  <div>
                    <el-button size="mini" class="coupons_detail_btn" round @click="showDetail(index)">查看详情 <i class="el-icon-arrow-down"></i></el-button>
                    <el-button size="mini" class="coupons_use_btn" round type="primary"
                     @click="immediateUse(item)">立即使用 <i class="el-icon-check"></i></el-button>
                  </div>
                </div>
                <div class="clearb"></div>
                <div class="coupons_detail" v-if="item.isShowDetail">{{item.remark}}</div> 
            </el-card>
        </el-col>
      </el-row>
    </el-tab-pane>
    <el-tab-pane name="2" label="不可使用">
      <el-row v-for="(item, index) in couponsItems.items">
        <el-col>
            <el-card shadow="hover" class="coupons">
                <div class="coupons_ammount coupons_ammount_pasted">$<span class="ammount">{{item.amount}}</span></div>
                <div class="coupons_content">
                  <div>来源：<span class="content reason">{{item.getReasonDesc}}</span></div>
                  <div>是否过期：
                    <el-tag type="info" class="content coupons_past">{{isLate(item.expirationTime)}}</el-tag>
                  </div>
                  <div>有效时间：<span class="content">{{isForever(item.expirationTime)}}</span></div>
                  <div>
                    <el-button size="mini" class="coupons_detail_btn" round @click="showDetail(index)">查看详情 <i class="el-icon-arrow-down"></i></el-button>
                  </div>
                </div>
                <div class="clearb"></div>
                <div class="coupons_detail" v-if="item.isShowDetail">{{item.remark}}</div> 
            </el-card>
        </el-col>
      </el-row>
    </el-tab-pane>
  </el-tabs>
  </div>
</template>
<script>
import moment from 'moment'
export default {
    name: 'myCoupons',
    props: {
      'randomVal': {
        default: 0,
        type: Number
      }
    },
    data() {
      return {
        couponsItems: {
          items: [],
          totalCount: 0
        },
        curTab: "1",
        canTotal: 0,
        filter: {
          CanUse: true,
          Page: null,
          Size: null
        }
      }
    },
    mounted() {
      this.getCoupons();
    },
    watch: {
      randomVal(val) {
        this.curTab = "1";
        this.canTotal = 0;
        this.filter.CanUse = true;
        this.getCoupons();
      }
    },
    methods: {
      getCoupons() {
        this.showPcLoading();
        this.couponsItems.items = [];
        this.$axios.get(window.consts.apis.getCoupons, {params: this.filter}).then(res => {
          this.hidePcLoading();
          if (res.success) {
            this.couponsItems = res.result;
            for (var i in res.result.items) {
              this.couponsItems.items[i].isShowDetail = false;
            }
            if (this.filter.CanUse) {
              this.canTotal = res.result.totalCount;
            }
          } else {
            this.$alert(res.error.message);
          }
        }).catch(e => {
          this.hidePcLoading();
          this.$message.error("加载数据失败!");
        })
      },
      tabClick() {
        this.filter.CanUse = this.curTab == 1 ? true :false;
        this.getCoupons();
      },
      showDetail(index) {
        var temp = {};
        for (var i in this.couponsItems.items[index]) {
          temp[i] = this.couponsItems.items[index][i];
        }
        if (temp.remark) {
          temp.isShowDetail = !temp.isShowDetail;
          this.$set(this.couponsItems.items, index, temp);
        } else {
          this.$message("暂无详细说明!")
        }
      },
      isLate(time) {
        let lateVal = "";
        if (moment(time).isValid() && moment().isAfter(time)) {
          lateVal = "已过期";
        } else {
          lateVal = "已使用";
        }
        return lateVal;
      },
      isForever(time) {
        return moment(time).isValid() ? time : "永久有效";
      },
      immediateUse(item) {
        this.$emit('immediateUse', item);
      }
    }
  }
</script>

